import React from 'react';

const Trope4: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-4 prefix__trope-decor"
      transform="translate(200, 174)"
    >
      <path
        d="M374.32,163.49s45.09-25,68.66-24.67c47.34.67,78.67,22,78.67,22s-20-26.68,2.67-30,12.66-26.66-4-40.66S479,51.49,429,66.16c-38.91,11.41-53.33,24.66-53.33,24.66s-14.94,8.26-14.06,16.45c2,18.5,21.92,10.61,21.06,17-.66,4.94-11.28,13.27-12.5,19A26,26,0,0,0,374.32,163.49Z"
        fill="#f1ce58"
      />
      <ellipse
        cx="367"
        cy="107.76"
        rx="5.43"
        ry="2"
        transform="translate(-15.13 91.07) rotate(-13.86)"
        fill="#e1a554"
      />
      <path
        d="M369.8,106.2c.49,2-1.39,2.59-4,3.24s-5,1.1-5.49-.89a5.49,5.49,0,0,1,3.69-6C366.61,102,369.31,104.22,369.8,106.2Z"
        fill="#eebf57"
      />
      <path
        d="M366.55,102.81a4.39,4.39,0,0,1,.92,1.7c.49,2-1.39,2.59-4,3.24a16.27,16.27,0,0,1-3.2.55,2.17,2.17,0,0,0,0,.25c.49,2,2.86,1.54,5.49.89s4.51-1.25,4-3.24A5.44,5.44,0,0,0,366.55,102.81Z"
        fill="#d6974f"
      />
      <path
        d="M455.65,100.82a21.41,21.41,0,0,0-21-2.5c-8.5,3.5-17.5,9.5-22,10.5s-14.5,3.5-14.5,10,14.5,8.5,25,3,29.5-3.5,35.5-4.5S459.15,103.32,455.65,100.82Z"
        fill="#eebf57"
      />
      <path
        d="M508.65,108.82c-13.69-6.22-23-7-31.5-5.5s-9.5,6.5-5,12.5,17,4,30,9.5,22.5,9,24,1S514.15,111.32,508.65,108.82Z"
        fill="#eebf57"
      />
      <path
        d="M358.32,138.82c8.11-.59,13.83-2.5,22.33-5.5s16-9.5,13.5-15.5-29-1.5-37.5,4.5S351.48,139.32,358.32,138.82Z"
        fill="#eebf57"
      />
      <path
        d="M429.15,71.16c-6.19-3-29.33,3.16-35.83,7.66s-17.67,13.34-17.17,23.34,24.5-3,35.5-5.5S444.65,78.66,429.15,71.16Z"
        fill="#eebf57"
      />
      <path
        d="M490.65,73.32a77.8,77.8,0,0,0-37.5-4.5c-11.5,1.5-13.5,9-13,15.5s10,4.5,18.5,5.5,40,6,38,0S495.65,75.32,490.65,73.32Z"
        fill="#eebf57"
      />
      <ellipse
        cx="527.2"
        cy="114.31"
        rx="2"
        ry="5.43"
        transform="translate(279.05 593.3) rotate(-74.85)"
        fill="#e1a554"
      />
      <path
        d="M530.41,114.31c-.54,2-2.48,1.59-5.09.88s-4.9-1.47-4.37-3.44a5.5,5.5,0,0,1,6.11-3.42C529.68,109,530.94,112.34,530.41,114.31Z"
        fill="#eebf57"
      />
      <path
        d="M529.21,109.77a4.46,4.46,0,0,1,0,1.93c-.54,2-2.48,1.58-5.09.88A15.26,15.26,0,0,1,521,111.5c0,.09-.07.17-.09.25-.53,2,1.76,2.73,4.37,3.44s4.55,1.09,5.09-.88A5.47,5.47,0,0,0,529.21,109.77Z"
        fill="#d6974f"
      />
      <ellipse cx="469.48" cy="99.98" rx="4.54" ry="1.67" fill="#e1a554" />
      <path
        d="M472.07,99.28c0,1.71-1.65,1.82-3.91,1.82s-4.27-.11-4.27-1.82a4.59,4.59,0,0,1,4.18-4.09A4.4,4.4,0,0,1,472.07,99.28Z"
        fill="#eebf57"
      />
      <path
        d="M470.11,95.88a3.63,3.63,0,0,1,.41,1.56c0,1.71-1.65,1.82-3.91,1.82a13.08,13.08,0,0,1-2.71-.19,1.48,1.48,0,0,0,0,.21c0,1.71,2,1.82,4.27,1.82s3.91-.11,3.91-1.82A4.58,4.58,0,0,0,470.11,95.88Z"
        fill="#d6974f"
      />
      <path
        d="M429.15,71.16a8.07,8.07,0,0,0-2.34-.64c6.67,8-11.67,20.42-21.41,22.64-7.55,1.71-21.23,8.38-29.23,9.15.76,9.69,24.54-3.17,35.48-5.65S444.65,78.66,429.15,71.16Z"
        fill="#e1a554"
      />
      <path
        d="M496.65,89.82c-1.5-4.5-1.31-10.41-3.24-13.92.58,3.17-.48,6.63-4.76,9.17-5.44,3.24-27,2-35.5,1-5.16-.6-9.95-.76-13-2.24l0,.49c.5,6.5,10,4.5,18.5,5.5S498.65,95.82,496.65,89.82Z"
        fill="#e1a554"
      />
      <path
        d="M394.15,117.82c-.53-1.27-2.15-2.07-4.44-2.48a2.27,2.27,0,0,1,.27.48c2.5,6-5,12.5-13.5,15.5s-14.21,4.91-22.33,5.5c-.21,0-.42,0-.62,0a5.67,5.67,0,0,0,4.79,2c8.11-.59,13.83-2.5,22.33-5.5S396.65,123.82,394.15,117.82Z"
        fill="#e1a554"
      />
      <polygon
        points="14.41 104.17 9.78 101.76 4.59 102.23 7 97.61 6.53 92.42 11.15 94.82 16.34 94.35 13.94 98.98 14.41 104.17"
        fill="#fff"
      />
      <path
        d="M455.65,100.82c-.36-.26-.74-.51-1.13-.75,2.51,4.76,4.07,11.54-.2,12.25-6,1-25-1-35.5,4.5-6.92,3.63-15.57,4-20.67,2v0c0,6.5,14.5,8.5,25,3s29.5-3.5,35.5-4.5S459.15,103.32,455.65,100.82Z"
        fill="#e1a554"
      />
      <ellipse cx="431.03" cy="96.48" rx="2.61" ry="0.96" fill="#e1a554" />
      <path
        d="M432.73,95.42c0,1-1,1-2.25,1s-2.45-.07-2.45-1a2.63,2.63,0,0,1,2.4-2.35A2.53,2.53,0,0,1,432.73,95.42Z"
        fill="#eebf57"
      />
      <path
        d="M431.6,93.47a2.06,2.06,0,0,1,.24.9c0,1-.95,1-2.25,1A7.28,7.28,0,0,1,428,95.3a.49.49,0,0,0,0,.12c0,1,1.15,1,2.45,1s2.25-.07,2.25-1A2.63,2.63,0,0,0,431.6,93.47Z"
        fill="#d6974f"
      />
      <path
        d="M525.88,122.78c-1.78,7.39-11.16,3.93-23.9-1.46-13-5.5-25.5-3.5-30-9.5a14.57,14.57,0,0,1-2.2-4c-.76,2.19.11,5,2.37,8,4.5,6,17,4,30,9.5s22.5,9,24,1A7,7,0,0,0,525.88,122.78Z"
        fill="#e1a554"
      />
      <path
        d="M193.65,127.55c0,7.61-15.29,10.27-33.33,10.27s-32-2.12-32-9.73,14-14.6,32-14.6S193.65,119.93,193.65,127.55Z"
        fill="#f1ce58"
      />
      <path
        d="M214.32,154.48c0,6.68-15.3,9-33.34,9s-32-1.86-32-8.53,14-12.8,32-12.8S214.32,147.81,214.32,154.48Z"
        fill="#f1ce58"
      />
      <path
        d="M253.65,132.73c0,5-11.45,6.75-25,6.75s-24-1.39-24-6.39,10.45-9.59,24-9.59S253.65,127.73,253.65,132.73Z"
        fill="#f1ce58"
      />
      <path
        d="M343.65,137.15c0,6.68-15.29,9-33.33,9s-32-1.86-32-8.54,14-12.8,32-12.8S343.65,130.47,343.65,137.15Z"
        fill="#f1ce58"
      />
      <path
        d="M711.31,107c2.71,4.9-7.57,12.83-20.82,20.16s-24.26,11.64-27,6.74,5-15.08,18.31-22.41S708.59,102.13,711.31,107Z"
        fill="#f1ce58"
      />
      <path
        d="M756.55,57.33c6.58,5.89.3,17.51-9.8,28.79S727,104.48,720.42,98.59s-4.79-20,5.32-31.3S750,51.44,756.55,57.33Z"
        fill="#f1ce58"
      />
      <path
        d="M787.19,65.1c4.8,4.31.22,12.8-7.17,21s-14.44,13.42-19.24,9.12-3.5-14.64,3.89-22.88S782.38,60.79,787.19,65.1Z"
        fill="#f1ce58"
      />
      <path
        d="M793.92,40.7c2.4,4.74-3.66,9.87-11.78,14s-15.08,6-17.47,1.23,1.7-12.26,9.83-16.36S791.53,36,793.92,40.7Z"
        fill="#f1ce58"
      />
      <path
        d="M888.69,75.64c-2.42,4.72-10.13,2.85-18.23-1.29S856.75,65.68,859.17,61s10.9-5.85,19-1.71S891.11,70.91,888.69,75.64Z"
        fill="#f1ce58"
      />
      <path
        d="M892.94,102.91c-2.42,4.72-13.15,1.31-24.82-4.66s-20-11.9-17.62-16.62,13.67-4.44,25.34,1.53S895.35,98.18,892.94,102.91Z"
        fill="#f1ce58"
      />
      <path
        d="M1009,89.57c1.48,6.08-10.73,11.3-25.74,15s-27.05,4.79-28.53-1.29,8.78-14.48,23.8-18.13S1007.48,83.49,1009,89.57Z"
        fill="#f1ce58"
      />
      <path
        d="M1009.15,89.76c-.69-2.86-4.14-4.82-9.15-5.72a5.63,5.63,0,0,1,2.4,3.22c1.48,6.07-10.73,11.29-25.75,14.95-8.31,2-15.71,3.27-20.91,3,3.3,4,14.29,2.8,27.66-.45C998.42,101.05,1010.63,95.83,1009.15,89.76Z"
        fill="#e1a554"
      />
      <path
        d="M718,142.09c2.49,5.74-8.67,12.94-22.86,19.07s-25.85,9.28-28.33,3.53,6.22-15.75,20.4-21.88S715.52,136.34,718,142.09Z"
        fill="#f1ce58"
      />
      <path
        d="M718.35,141.9c-1-2.39-4.09-3.72-8.32-4a4.92,4.92,0,0,1,1.49,1.9c2.48,5.74-8.67,12.94-22.86,19.07-8.32,3.6-15.78,6.17-21,6.52,3.27,4.54,14.43,1.41,27.85-4.39C709.68,154.84,720.83,147.64,718.35,141.9Z"
        fill="#e1a554"
      />
      <path
        d="M1010.25,126.61c1.48,6.08-10.73,11.29-25.74,15s-27,4.79-28.53-1.29,8.78-14.48,23.8-18.13S1008.77,120.53,1010.25,126.61Z"
        fill="#f1ce58"
      />
      <path
        d="M1010.63,126.48c-.62-2.53-3.41-4.36-7.53-5.37a4.86,4.86,0,0,1,1.15,2.12c1.48,6.08-10.73,11.3-25.74,15-8.81,2.15-16.59,3.42-21.82,2.88,2.46,5,14,3.83,28.19.37C999.9,137.78,1012.11,132.56,1010.63,126.48Z"
        fill="#e1a554"
      />
      <path
        d="M954.89,133.58c-1.44,6.09-14.69,5.21-29.73,1.67s-26.29-8-24.85-14.07,14.39-8.93,29.43-5.39S956.32,127.49,954.89,133.58Z"
        fill="#f1ce58"
      />
      <path
        d="M955.28,133.64c.59-2.54-1.06-5.43-4.28-8.2a4.86,4.86,0,0,1,.06,2.42c-1.43,6.08-14.68,5.21-29.72,1.66-8.83-2.07-16.34-4.46-20.76-7.31-.08,5.6,10.74,9.75,25,13.1C940.59,138.85,953.84,139.73,955.28,133.64Z"
        fill="#e1a554"
      />
      <path
        d="M1139.74,9.13c1,4.12-7.27,7.66-17.44,10.13S1104,22.51,1103,18.39s6-9.81,16.13-12.29S1138.74,5,1139.74,9.13Z"
        fill="#f1ce58"
      />
      <path
        d="M1173.08,19.47c1,4.11-7.27,7.65-17.45,10.13s-18.32,3.24-19.32-.88,6-9.81,16.12-12.28S1172.07,15.35,1173.08,19.47Z"
        fill="#f1ce58"
      />
      <path
        d="M1294.66,37.63c2.79,3.19-2.91,10.15-10.79,17s-14.74,11.35-17.53,8.16.74-11.45,8.61-18.35S1291.86,34.44,1294.66,37.63Z"
        fill="#f1ce58"
      />
      <path
        d="M1287,64.2c1.71,2-1.77,6.2-6.59,10.42s-9,6.93-10.71,5,.45-7,5.26-11.21S1285.33,62.25,1287,64.2Z"
        fill="#f1ce58"
      />
      <path
        d="M1261.77,70.09c3,3.43-3.13,10.9-11.59,18.32s-15.84,12.19-18.84,8.77.8-12.3,9.26-19.72S1258.77,66.67,1261.77,70.09Z"
        fill="#f1ce58"
      />
      <path
        d="M1270.7,89.83c2.42,2.77-2.53,8.82-9.37,14.81s-12.81,9.87-15.24,7.1.64-9.95,7.48-15.95S1268.27,87.06,1270.7,89.83Z"
        fill="#f1ce58"
      />
      <path
        d="M1196.52,289.87c-3.34-1.55-4.86-10.69-1-18.94s11.34-12.59,14.68-11,3.43,9.36-.4,17.61S1199.86,291.42,1196.52,289.87Z"
        fill="#f1ce58"
      />
      <path
        d="M1213.83,291.38c-3.36-2.38-3.21-12.74,2.67-21.05s15-11.6,18.37-9.22,1.91,11-4,19.3S1217.2,293.76,1213.83,291.38Z"
        fill="#f1ce58"
      />
      <path
        d="M1188.68,318.26c-2.59-2.61-.83-11.71,5.63-18.1s15-7.87,17.61-5.26,0,10-6.51,16.37S1191.27,320.88,1188.68,318.26Z"
        fill="#f1ce58"
      />
      <path
        d="M1164.68,320.93c-2.59-2.62-.83-11.71,5.63-18.11s15-7.87,17.61-5.25,0,10-6.51,16.37S1167.27,323.55,1164.68,320.93Z"
        fill="#f1ce58"
      />
      <path
        d="M1179,354.6c-2.59-2.62-.84-11.71,5.63-18.11s15-7.87,17.6-5.25,0,10-6.5,16.37S1181.61,357.21,1179,354.6Z"
        fill="#f1ce58"
      />
      <path
        d="M1151.35,352.26c-2.59-2.61-.84-11.71,5.63-18.1s15-7.87,17.6-5.26,0,10-6.5,16.37S1153.94,354.88,1151.35,352.26Z"
        fill="#f1ce58"
      />
      <path
        d="M1035,420.28c-.72-5.06,8.75-13.74,21.24-15.53s23.24,3.63,24,8.69-8.28,11.08-20.77,12.87S1035.76,425.34,1035,420.28Z"
        fill="#f1ce58"
      />
      <path
        d="M1034.51,444.48c-.53-3.65,6.3-9.91,15.3-11.2s16.75,2.62,17.27,6.27-6,8-15,9.28S1035,448.12,1034.51,444.48Z"
        fill="#f1ce58"
      />
      <path
        d="M1108.88,370.3c-.61-4.21,7.57-11.48,18.32-13s20,2.93,20.57,7.15-7.16,9.27-17.92,10.81S1109.48,374.52,1108.88,370.3Z"
        fill="#f1ce58"
      />
      <path
        d="M1130.27,29.08c.73,3-5.27,5.55-12.64,7.35s-13.28,2.35-14-.64,4.31-7.11,11.69-8.9S1129.55,26.1,1130.27,29.08Z"
        fill="#f1ce58"
      />
      <path
        d="M1046,106.07c.44,5.45-10.82,8.26-24.28,9.33s-24,.39-24.42-5.05,9.58-11.28,23-12.35S1045.57,100.62,1046,106.07Z"
        fill="#f1ce58"
      />
      <path
        d="M1046,106.32a5.59,5.59,0,0,0-2.5-3.86c.23,5.36-10.94,8.13-24.28,9.19-9.77.78-18,.64-21.93-1.59a3.25,3.25,0,0,0,0,.54c.43,5.44,11,6.13,24.42,5.05S1046.44,111.77,1046,106.32Z"
        fill="#e1a554"
      />
      <path
        d="M936.27,106.91c-2.41,4.72-13.15,1.31-24.82-4.66s-20-11.9-17.61-16.62,13.66-4.44,25.33,1.53S938.69,102.18,936.27,106.91Z"
        fill="#f1ce58"
      />
      <path
        d="M935.24,100.19l-.09.22c-2.42,4.72-13.16,1.31-24.83-4.66C903,92,897,88.27,894.11,84.84a4.81,4.81,0,0,0-.27.41c-2.42,4.72,5.94,10.66,17.61,16.63s22.41,9.38,24.82,4.65C937.13,104.85,936.69,102.63,935.24,100.19Z"
        fill="#e1a554"
      />
      <path
        d="M664,146.82c-.27,6.67-15.64,8.39-33.67,7.67s-31.9-3.12-31.63-9.79,14.45-12.24,32.48-11.52S664.28,140.15,664,146.82Z"
        fill="#f1ce58"
      />
      <path
        d="M345.52,160.17c0,5.43-12.42,7.32-27.08,7.32s-26-1.51-26-6.93,11.34-10.4,26-10.4S345.52,154.75,345.52,160.17Z"
        fill="#f1ce58"
      />
      <path
        d="M285,155.15c0,6.68-15.29,9-33.33,9s-32-1.86-32-8.54,14-12.8,32-12.8S285,148.47,285,155.15Z"
        fill="#f1ce58"
      />
      <path
        d="M58.27,117.27c-4.62,8.17-19.55,3.5-35.25-5.39s-26.57-18-21.95-26.2,21-8.79,36.72.09S62.89,109.1,58.27,117.27Z"
        fill="#f1ce58"
      />
      <path
        d="M59.86,149.05c-3.09,7.37-16.17,4.92-30.33-1S5.27,135.48,8.36,128.11s16.87-9.54,31-3.61S62.94,141.69,59.86,149.05Z"
        fill="#f1ce58"
      />
      <path
        d="M119,129.43c-1.49,7.85-14.8,8.16-29.88,5.3s-26.34-7.26-24.85-15.11,14.52-12.83,29.61-10S120.46,121.58,119,129.43Z"
        fill="#f1ce58"
      />
      <path
        d="M136.35,153.65c1.34,7.87-11,12.81-26.16,15.38S83,171.41,81.64,163.54s9.13-17.1,24.27-19.67S135,145.77,136.35,153.65Z"
        fill="#f1ce58"
      />
      <path
        d="M332.86,151.75c1.7,1.3,2.66,2.74,2.66,4.25,0,5.43-12.42,7.32-27.08,7.32a111.05,111.05,0,0,1-15.46-.87c2.41,3.89,12.67,5,25.46,5,14.66,0,27.08-1.89,27.08-7.32C345.52,156.69,340.4,153.55,332.86,151.75Z"
        fill="#e1a554"
      />
      <path
        d="M328.71,127c2,1.71,3.18,3.6,3.18,5.58,0,7.13-14.82,9.61-32.3,9.61A118.71,118.71,0,0,1,281.15,141c2.88,5.12,15.11,6.63,30.36,6.63,17.49,0,32.31-2.49,32.31-9.61C343.82,133.47,337.7,129.35,328.71,127Z"
        fill="#e1a554"
      />
      <path
        d="M269.54,144.49c2,1.71,3.18,3.6,3.18,5.58,0,7.13-14.82,9.61-32.3,9.61A118.71,118.71,0,0,1,222,158.53c2.88,5.12,15.12,6.63,30.37,6.63,17.48,0,32.3-2.49,32.3-9.61C284.65,151,278.54,146.85,269.54,144.49Z"
        fill="#e1a554"
      />
      <path
        d="M242.21,125c1.58,1.27,2.48,2.67,2.48,4.14,0,5.29-11.55,7.13-25.17,7.13a97.56,97.56,0,0,1-14.37-.85c2.24,3.79,11.78,4.91,23.66,4.91,13.63,0,25.17-1.84,25.17-7.13C254,129.8,249.22,126.74,242.21,125Z"
        fill="#e1a554"
      />
      <path
        d="M199.82,144.66c2.13,1.58,3.33,3.34,3.33,5.18,0,6.6-15.53,8.91-33.85,8.91A141.75,141.75,0,0,1,150,157.68c3,4.74,15.84,6.14,31.82,6.14,18.32,0,33.85-2.3,33.85-8.91C215.65,150.67,209.25,146.85,199.82,144.66Z"
        fill="#e1a554"
      />
      <path
        d="M178.82,116.66c2.13,1.81,3.33,3.82,3.33,5.92,0,7.55-15.53,10.19-33.85,10.19A124.29,124.29,0,0,1,129,131.55c3,5.42,15.84,7,31.82,7,18.32,0,33.85-2.63,33.85-10.19C194.65,123.53,188.25,119.16,178.82,116.66Z"
        fill="#e1a554"
      />
      <path
        d="M120.37,144.9a8.45,8.45,0,0,1,4.18,5c1.87,7.32-10.14,13.1-25.08,16.9-6,1.52-11.47-1.43-16-1.18,3.79,4.63,14.64,7.53,27.67,4.21C126,166.08,138,160.3,136.18,153,135,148.28,128.68,145.38,120.37,144.9Z"
        fill="#e1a554"
      />
      <path
        d="M107.06,115.11a8.22,8.22,0,0,1,2.2,6.15c-.89,7.41-14.7,8.37-30.63,6.45A95.47,95.47,0,0,1,62,124.5c2,5.63,12.94,8.53,26.84,10.2,15.92,1.92,29.73,1,30.62-6.45C120,123.5,115,118.56,107.06,115.11Z"
        fill="#e1a554"
      />
      <path
        d="M53.89,100a10.4,10.4,0,0,1,0,7.59c-3.52,8.14-17.77,5.36-33.13-1.27A88.71,88.71,0,0,1,5.17,98c0,6.93,10,13.3,23.41,19.09,15.36,6.63,29.61,9.41,33.13,1.27C64,113.15,60.63,106.12,53.89,100Z"
        fill="#e1a554"
      />
      <ellipse
        cx="271.06"
        cy="135.72"
        rx="2"
        ry="5.43"
        transform="translate(133.03 405.61) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M274.16,134.91c0,2-2,2.16-4.7,2.14s-5.12-.18-5.1-2.22a5.5,5.5,0,0,1,5.05-4.86C272.11,130,274.17,132.87,274.16,134.91Z"
        fill="#eebf57"
      />
      <path
        d="M271.85,130.82a4.49,4.49,0,0,1,.47,1.87c0,2.05-2,2.16-4.7,2.14a15.74,15.74,0,0,1-3.24-.26,2.11,2.11,0,0,0,0,.26c0,2,2.39,2.19,5.1,2.22s4.68-.1,4.7-2.14A5.47,5.47,0,0,0,271.85,130.82Z"
        fill="#d6974f"
      />
      <ellipse
        cx="291.9"
        cy="152.25"
        rx="1.5"
        ry="4.08"
        transform="translate(137.16 442.85) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M294.23,151.64c0,1.54-1.5,1.62-3.53,1.61s-3.84-.14-3.82-1.67a4.12,4.12,0,0,1,3.79-3.64A4,4,0,0,1,294.23,151.64Z"
        fill="#eebf57"
      />
      <path
        d="M292.5,148.57a3.48,3.48,0,0,1,.35,1.41c0,1.53-1.5,1.62-3.53,1.6a11.2,11.2,0,0,1-2.43-.19c0,.06,0,.13,0,.19,0,1.53,1.79,1.65,3.82,1.67s3.51-.07,3.53-1.61A4.12,4.12,0,0,0,292.5,148.57Z"
        fill="#d6974f"
      />
      <ellipse
        cx="197.45"
        cy="139.27"
        rx="1.71"
        ry="4.65"
        transform="matrix(0.01, -1, 1, 0.01, 56.5, 335.52)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M200.1,138.57c0,1.75-1.7,1.85-4,1.83s-4.37-.15-4.36-1.9a4.71,4.71,0,0,1,4.32-4.15A4.5,4.5,0,0,1,200.1,138.57Z"
        fill="#eebf57"
      />
      <path
        d="M198.13,135.07a3.78,3.78,0,0,1,.4,1.6c0,1.75-1.71,1.85-4,1.83a13.52,13.52,0,0,1-2.77-.22,1.64,1.64,0,0,0,0,.22c0,1.75,2.05,1.88,4.36,1.9s4-.08,4-1.83A4.68,4.68,0,0,0,198.13,135.07Z"
        fill="#d6974f"
      />
      <ellipse
        cx="350.02"
        cy="151.92"
        rx="1.32"
        ry="3.6"
        transform="translate(195.11 500.62) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M352.07,151.38c0,1.35-1.32,1.43-3.11,1.41s-3.39-.11-3.38-1.47a3.63,3.63,0,0,1,3.34-3.21A3.49,3.49,0,0,1,352.07,151.38Z"
        fill="#eebf57"
      />
      <path
        d="M350.54,148.67a3,3,0,0,1,.31,1.24c0,1.35-1.32,1.43-3.11,1.42a10.59,10.59,0,0,1-2.15-.18c0,.06,0,.12,0,.17,0,1.36,1.58,1.46,3.38,1.47s3.1-.06,3.11-1.41A3.63,3.63,0,0,0,350.54,148.67Z"
        fill="#d6974f"
      />
      <path
        d="M657.67,139a3.85,3.85,0,0,1,0,.48c-.26,6.68-15.63,8.4-33.66,7.68-10.89-.43-20.25-1.48-25.91-3.72a5.9,5.9,0,0,0-.06.59c-.27,6.67,13.61,9.08,31.64,9.8s33.4-1,33.66-7.68C663.45,143.61,661.33,141.13,657.67,139Z"
        fill="#e1a554"
      />
      <path
        d="M705,104.38c1.71,4.93-8.29,12.55-21.06,19.61-8.34,4.61-15.78,8-20.83,8.7a4.12,4.12,0,0,0,.43,1.25c2.72,4.9,13.72.59,27-6.74S714,111.94,711.31,107C710.36,105.32,708.09,104.46,705,104.38Z"
        fill="#e1a554"
      />
      <path
        d="M765.3,110.15c2.44,5-8.26,12.39-21.9,19s-24.86,10.29-27.3,5.24S722,119.61,735.61,113,762.86,105.1,765.3,110.15Z"
        fill="#f1ce58"
      />
      <path
        d="M759.12,107.15c1.44,5-9,12.07-22.11,18.42-8.57,4.15-16.2,7.15-21.28,7.55a4.17,4.17,0,0,0,.37,1.26c2.44,5.05,13.67,1.35,27.3-5.24s24.34-13.95,21.9-19C764.45,108.39,762.23,107.4,759.12,107.15Z"
        fill="#e1a554"
      />
      <path
        d="M756.55,57.33c-2.49-2.23-6.08-3-10.11-2.39A9.37,9.37,0,0,1,747.88,56c6.58,5.89.31,17.51-9.8,28.78-6.19,6.91-12.21,12.24-17.45,14,6.57,5.56,16.12-1.49,26.12-12.65S763.13,63.22,756.55,57.33Z"
        fill="#e1a554"
      />
      <path
        d="M787.19,65.1c-2.45-2.19-6.34-2.39-10.54-1a7,7,0,0,1,2.2,1.31c4.81,4.31.22,12.8-7.16,21-3.63,4-7.17,7.35-10.41,9.16,4.78,3.55,11.6-1.53,18.74-9.49C787.41,77.9,792,69.41,787.19,65.1Z"
        fill="#e1a554"
      />
      <path
        d="M793.92,40.7a7.1,7.1,0,0,0-4.76-3.44,5.32,5.32,0,0,1,.76,1.11c2.4,4.74-3.66,9.87-11.78,14-5.17,2.61-9.87,4.31-13.21,4,2.59,4.17,9.34,2.33,17.21-1.65C790.26,50.57,796.32,45.44,793.92,40.7Z"
        fill="#e1a554"
      />
      <ellipse
        cx="649.15"
        cy="130"
        rx="1.5"
        ry="4.08"
        transform="translate(513.61 778.02) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M651.48,129.39c0,1.54-1.5,1.62-3.53,1.61s-3.84-.14-3.82-1.67a4.12,4.12,0,0,1,3.79-3.64A4,4,0,0,1,651.48,129.39Z"
        fill="#eebf57"
      />
      <path
        d="M649.75,126.32a3.48,3.48,0,0,1,.35,1.41c0,1.53-1.5,1.62-3.53,1.6a11.2,11.2,0,0,1-2.43-.19c0,.06,0,.13,0,.19,0,1.53,1.79,1.65,3.82,1.67s3.52-.07,3.53-1.61A4.12,4.12,0,0,0,649.75,126.32Z"
        fill="#d6974f"
      />
      <ellipse
        cx="756.52"
        cy="46.68"
        rx="4.08"
        ry="1.5"
        transform="translate(49.29 319.32) rotate(-24.61)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M758.37,45.15c.64,1.39-.67,2.1-2.51,2.94s-3.53,1.51-4.17.12a4.13,4.13,0,0,1,1.88-4.91A4,4,0,0,1,758.37,45.15Z"
        fill="#eebf57"
      />
      <path
        d="M755.5,43.1a3.15,3.15,0,0,1,.91,1.12c.64,1.4-.66,2.11-2.51,3a10.64,10.64,0,0,1-2.28.85,1.07,1.07,0,0,0,.07.19c.64,1.39,2.32.73,4.17-.12s3.15-1.55,2.51-2.94A4.11,4.11,0,0,0,755.5,43.1Z"
        fill="#d6974f"
      />
      <ellipse
        cx="766.77"
        cy="64.43"
        rx="4.08"
        ry="1.5"
        transform="translate(42.83 325.21) rotate(-24.61)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M768.62,62.9c.64,1.39-.67,2.1-2.51,2.94s-3.53,1.51-4.17.12a4.13,4.13,0,0,1,1.88-4.91A4,4,0,0,1,768.62,62.9Z"
        fill="#eebf57"
      />
      <path
        d="M765.75,60.85a3.15,3.15,0,0,1,.91,1.12c.64,1.4-.66,2.11-2.51,3a11.2,11.2,0,0,1-2.28.85,1.07,1.07,0,0,0,.07.19c.64,1.39,2.32.73,4.17-.12s3.15-1.55,2.51-2.94A4.11,4.11,0,0,0,765.75,60.85Z"
        fill="#d6974f"
      />
      <path
        d="M872.37,94.5c-10.87-5.55-18.85-11.08-18-15.62a5.93,5.93,0,0,0-3.91,2.75c-2.41,4.72,6,10.65,17.62,16.62s22.4,9.38,24.82,4.66a4.08,4.08,0,0,0,.42-1.6C888.68,101.76,880.78,98.8,872.37,94.5Z"
        fill="#e1a554"
      />
      <path
        d="M872.21,70.85c-7-3.59-12.16-7.47-11.83-11.52A6.58,6.58,0,0,0,859.17,61c-2.42,4.72,3.18,9.24,11.29,13.39s15.81,6,18.23,1.29a5.66,5.66,0,0,0,.58-2C886.06,76.35,879.28,74.47,872.21,70.85Z"
        fill="#e1a554"
      />
      <ellipse
        cx="852.66"
        cy="72.09"
        rx="1.5"
        ry="4.08"
        transform="translate(528.54 864.03) rotate(-72.57)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M855.07,72.18c-.46,1.47-1.91,1.12-3.84.51s-3.64-1.25-3.18-2.71a4.13,4.13,0,0,1,4.69-2.38A4,4,0,0,1,855.07,72.18Z"
        fill="#eebf57"
      />
      <path
        d="M854.3,68.74a3.31,3.31,0,0,1-.07,1.45c-.46,1.46-1.9,1.11-3.84.51a11.66,11.66,0,0,1-2.27-.9l-.07.18c-.46,1.46,1.24,2.1,3.18,2.71s3.38,1,3.84-.51A4.13,4.13,0,0,0,854.3,68.74Z"
        fill="#d6974f"
      />
      <ellipse
        cx="898.79"
        cy="77.84"
        rx="1.5"
        ry="4.08"
        transform="translate(555.37 912.07) rotate(-72.57)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M901.19,77.93c-.46,1.47-1.9,1.12-3.84.51s-3.63-1.25-3.17-2.71a4.12,4.12,0,0,1,4.68-2.38A4,4,0,0,1,901.19,77.93Z"
        fill="#eebf57"
      />
      <path
        d="M900.43,74.49a3.31,3.31,0,0,1-.07,1.45c-.46,1.46-1.91,1.11-3.84.51a11.66,11.66,0,0,1-2.27-.9,1.34,1.34,0,0,0-.07.18c-.46,1.46,1.23,2.1,3.17,2.71s3.38,1,3.84-.51A4.08,4.08,0,0,0,900.43,74.49Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1023.83"
        cy="92.85"
        rx="4.08"
        ry="1.5"
        transform="matrix(1, -0.07, 0.07, 1, -4.04, 74.62)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1026.1,92.05c.11,1.53-1.36,1.74-3.38,1.88s-3.84.18-4-1.35a4.1,4.1,0,0,1,3.48-3.93A4,4,0,0,1,1026.1,92.05Z"
        fill="#eebf57"
      />
      <path
        d="M1024.12,89.13a3.2,3.2,0,0,1,.47,1.37c.11,1.53-1.36,1.74-3.38,1.89a11.65,11.65,0,0,1-2.44,0,1.21,1.21,0,0,0,0,.19c.11,1.53,1.92,1.5,4,1.35s3.49-.35,3.38-1.88A4.08,4.08,0,0,0,1024.12,89.13Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1029.63"
        cy="123.69"
        rx="4.08"
        ry="1.5"
        transform="translate(-6.27 75.12) rotate(-4.17)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1031.9,122.89c.11,1.53-1.36,1.74-3.38,1.89s-3.84.18-4-1.35a4.12,4.12,0,0,1,3.48-3.94A4,4,0,0,1,1031.9,122.89Z"
        fill="#eebf57"
      />
      <path
        d="M1029.92,120a3.24,3.24,0,0,1,.47,1.38c.11,1.53-1.36,1.74-3.38,1.88a11,11,0,0,1-2.44,0,1.33,1.33,0,0,0,0,.2c.11,1.53,1.92,1.5,4,1.35s3.49-.36,3.38-1.89A4.1,4.1,0,0,0,1029.92,120Z"
        fill="#d6974f"
      />
      <path
        d="M1139.74,9.13c-.33-1.38-1.63-2.44-3.57-3.16-.38,3.7-8.12,6.89-17.5,9.17-6.53,1.59-12.22,2.46-15.72,1.8a3.53,3.53,0,0,0,0,1.45c1,4.12,9.16,3.35,19.33.87S1140.74,13.25,1139.74,9.13Z"
        fill="#e1a554"
      />
      <path
        d="M1130.27,29.08c-.25-1-1.23-1.8-2.69-2.33-.07,2.76-5.78,5.12-12.7,6.8-4.67,1.14-8.74,1.77-11.29,1.33a2.51,2.51,0,0,0,0,.91c.73,3,6.63,2.43,14,.64S1131,32.07,1130.27,29.08Z"
        fill="#e1a554"
      />
      <path
        d="M1173.08,19.47a4,4,0,0,0-1.83-2.3c-1.12,3.44-8.52,6.4-17.37,8.55-7.82,1.9-14.44,2.79-17.53,1.23a3.67,3.67,0,0,0,0,1.77c1,4.12,9.15,3.35,19.32.88S1174.08,23.58,1173.08,19.47Z"
        fill="#e1a554"
      />
      <ellipse
        cx="1145.42"
        cy="15.36"
        rx="4.08"
        ry="1.5"
        transform="translate(27.97 267.4) rotate(-13.48)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1147.53,14.21c.36,1.49-1.06,1.93-3,2.4s-3.75.8-4.11-.69a4.12,4.12,0,0,1,2.8-4.45A4,4,0,0,1,1147.53,14.21Z"
        fill="#eebf57"
      />
      <path
        d="M1145.11,11.64a3.36,3.36,0,0,1,.68,1.29c.36,1.49-1.06,1.93-3,2.4a11.75,11.75,0,0,1-2.4.4l0,.19c.36,1.49,2.14,1.17,4.11.69s3.4-.91,3-2.4A4.09,4.09,0,0,0,1145.11,11.64Z"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <ellipse
        cx="1104.07"
        cy="5.63"
        rx="5.79"
        ry="2.12"
        transform="translate(29.1 257.49) rotate(-13.48)"
        fill="#e1a554"
      />
      <path
        d="M1107.07,4c.5,2.11-1.51,2.74-4.31,3.41s-5.33,1.13-5.84-1,1.17-5.65,4-6.32S1106.56,1.88,1107.07,4Z"
        fill="#eebf57"
      />
      <path
        d="M1103.63.36a4.69,4.69,0,0,1,1,1.82c.5,2.11-1.51,2.74-4.31,3.41a16.36,16.36,0,0,1-3.41.57,2.51,2.51,0,0,0,0,.27c.51,2.11,3,1.65,5.84,1s4.81-1.3,4.31-3.41A5.85,5.85,0,0,0,1103.63.36Z"
        fill="#d6974f"
      />
      <path
        d="M1294.66,37.63c-.86-1-2.3-1.35-4.12-1.22.77,3.55-4.47,9.68-11.42,15.77-5.29,4.64-10.13,8.16-13.58,9a3.73,3.73,0,0,0,.8,1.66c2.79,3.19,9.66-1.26,17.53-8.16S1297.45,40.82,1294.66,37.63Z"
        fill="#e1a554"
      />
      <path
        d="M1287,64.2a2.88,2.88,0,0,0-2.41-.74c-.16,2.22-3.16,5.62-7,9-3.31,2.9-6.33,5.09-8.45,5.55a2.57,2.57,0,0,0,.57,1.61c1.7,1.94,5.9-.78,10.71-5S1288.74,66.15,1287,64.2Z"
        fill="#e1a554"
      />
      <path
        d="M1270.7,89.83a3.78,3.78,0,0,0-2.89-1.08c-.15,3.16-4.45,8-10,12.89-5,4.38-9.52,7.6-12.54,8a3.55,3.55,0,0,0,.8,2.14c2.43,2.77,8.39-1.1,15.24-7.1S1273.12,92.6,1270.7,89.83Z"
        fill="#e1a554"
      />
      <path
        d="M1261.77,70.09A3.81,3.81,0,0,0,1260,69c-.5,3.91-5.67,9.75-12.3,15.55-7.28,6.38-13.75,10.8-17.33,9.73a4.49,4.49,0,0,0,1,2.88c3,3.42,10.38-1.36,18.84-8.77S1264.77,73.52,1261.77,70.09Z"
        fill="#e1a554"
      />
      <ellipse
        cx="1257.53"
        cy="59.86"
        rx="4.75"
        ry="1.74"
        transform="translate(200.01 742.95) rotate(-35.59)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1259.3,57.7c1,1.45-.3,2.55-2.22,3.92s-3.7,2.51-4.74,1.05a4.8,4.8,0,0,1,1.07-6C1255.33,55.28,1258.26,56.24,1259.3,57.7Z"
        fill="#eebf57"
      />
      <path
        d="M1255.57,56a3.89,3.89,0,0,1,1.29,1.09c1,1.45-.29,2.55-2.22,3.92a13.15,13.15,0,0,1-2.42,1.48l.12.19c1,1.46,2.82.32,4.74-1.05s3.26-2.47,2.22-3.92A4.77,4.77,0,0,0,1255.57,56Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1257.16"
        cy="88.74"
        rx="3.76"
        ry="1.38"
        transform="translate(183.13 748.13) rotate(-35.59)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1258.56,87c.82,1.15-.24,2-1.76,3.11s-2.93,2-3.76.84a3.82,3.82,0,0,1,.85-4.78A3.65,3.65,0,0,1,1258.56,87Z"
        fill="#eebf57"
      />
      <path
        d="M1255.6,85.67a3.05,3.05,0,0,1,1,.86c.82,1.15-.24,2-1.76,3.11a10.64,10.64,0,0,1-1.92,1.17l.09.16c.83,1.15,2.24.25,3.76-.84s2.58-2,1.76-3.11A3.77,3.77,0,0,0,1255.6,85.67Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1283.98"
        cy="80.86"
        rx="5.15"
        ry="1.89"
        transform="translate(192.72 762.27) rotate(-35.59)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1285.9,78.51c1.13,1.58-.32,2.77-2.4,4.26s-4,2.72-5.15,1.15a5.23,5.23,0,0,1,1.16-6.54C1281.6,75.89,1284.78,76.94,1285.9,78.51Z"
        fill="#eebf57"
      />
      <path
        d="M1281.85,76.66a4.27,4.27,0,0,1,1.41,1.18c1.13,1.58-.32,2.77-2.41,4.26a14.69,14.69,0,0,1-2.63,1.61,2.39,2.39,0,0,1,.13.21c1.13,1.57,3.06.34,5.15-1.15s3.53-2.68,2.4-4.26A5.19,5.19,0,0,0,1281.85,76.66Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1285.65"
        cy="32.28"
        rx="5.15"
        ry="1.89"
        transform="matrix(0.81, -0.58, 0.58, 0.81, 221.31, 754.16)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1287.57,29.93c1.12,1.58-.33,2.77-2.41,4.26s-4,2.72-5.14,1.14a5.2,5.2,0,0,1,1.15-6.53C1283.26,27.31,1286.44,28.36,1287.57,29.93Z"
        fill="#eebf57"
      />
      <path
        d="M1283.51,28.08a4.17,4.17,0,0,1,1.41,1.18c1.13,1.57-.32,2.77-2.41,4.26a14.32,14.32,0,0,1-2.62,1.6,1.48,1.48,0,0,0,.13.21c1.12,1.58,3,.35,5.14-1.14s3.53-2.68,2.41-4.26A5.19,5.19,0,0,0,1283.51,28.08Z"
        fill="#d6974f"
      />
      <path
        d="M1234.87,261.11c-1.48-1.05-4.08-1-7,.1,1.63,3.48-.16,10.75-5.15,17.81a34.91,34.91,0,0,1-10.43,10.07,4.67,4.67,0,0,0,1.56,2.29c3.37,2.38,11.19-2.65,17.07-11S1238.23,263.48,1234.87,261.11Z"
        fill="#e1a554"
      />
      <path
        d="M1078.61,438.92c-1.44-3.86,4.52-12.34,14.05-15.91s18.93-1.14,20.38,2.72-4.61,10.16-14.15,13.72S1080.05,442.78,1078.61,438.92Z"
        fill="#f1ce58"
      />
      <path
        d="M1113,425.73c-.64-1.7-2.82-3.12-5.86-3.87-.62,3.8-6.18,8.8-14.29,11.83a34.78,34.78,0,0,1-14.28,2.45,4.68,4.68,0,0,0,0,2.78c1.44,3.86,10.75,4.1,20.28.53S1114.48,429.59,1113,425.73Z"
        fill="#e1a554"
      />
      <path
        d="M1210.18,259.89c-1.57-.73-4.07-.14-6.68,1.54a5.16,5.16,0,0,1,3.67-.07c3.34,1.55,3.43,9.36-.4,17.61-2.31,5-5.43,9-8.28,11.07,3.42-.69,8.12-5.73,11.29-12.54C1213.61,269.25,1213.52,261.44,1210.18,259.89Z"
        fill="#e1a554"
      />
      <path
        d="M1211.92,294.9c-1.47-1.48-4.85-1.65-8.67-.36,2.06-.14,3.75.27,4.67,1.2,2.59,2.62,0,10-6.51,16.37a32,32,0,0,1-10.28,7.05c3.53.11,9.27-2.92,14.28-7.89C1211.88,304.87,1214.51,297.52,1211.92,294.9Z"
        fill="#e1a554"
      />
      <path
        d="M1202.25,331.24c-1.52-1.54-5.09-1.65-9.08-.21a5.82,5.82,0,0,1,4.41,1.21c2.6,2.62,0,10-6.5,16.37a32.7,32.7,0,0,1-9.82,6.88c3.51.23,9.37-2.82,14.49-7.88C1202.21,341.21,1204.84,333.86,1202.25,331.24Z"
        fill="#e1a554"
      />
      <path
        d="M1147,383.82c-1.61-3.31,3-11.35,11.17-15.33s16.75-2.6,18.36.71-3.25,9.42-11.44,13.4S1148.61,387.13,1147,383.82Z"
        fill="#f1ce58"
      />
      <path
        d="M1176.53,369.2c-.94-1.94-4.29-3.21-8.53-3.13,1.87.55,3.24,1.44,3.79,2.57,1.61,3.31-3.25,9.43-11.44,13.4a32.44,32.44,0,0,1-11.51,3.34c3.24,1.36,9.78.36,16.25-2.78C1173.28,378.62,1178.14,372.51,1176.53,369.2Z"
        fill="#e1a554"
      />
      <path
        d="M1113.47,413.06c-1.91-3.15,1.93-11.58,9.71-16.28s16.44-4.13,18.35-1-2.38,9.68-10.16,14.39S1115.37,416.21,1113.47,413.06Z"
        fill="#f1ce58"
      />
      <path
        d="M1141.53,395.8c-1.12-1.85-4.56-2.8-8.79-2.33,1.92.37,3.37,1.13,4,2.21,1.9,3.15-2.38,9.68-10.16,14.39a32.67,32.67,0,0,1-11.16,4.38c3.35,1.05,9.77-.54,15.93-4.26C1139.15,405.48,1143.43,399,1141.53,395.8Z"
        fill="#e1a554"
      />
      <path
        d="M1085.42,404c-1.67-3.28,2.77-11.41,10.87-15.54s16.7-2.93,18.37.35-3.07,9.48-11.17,13.61S1087.1,407.23,1085.42,404Z"
        fill="#f1ce58"
      />
      <path
        d="M1114.66,388.76c-1-1.93-4.35-3.12-8.59-3,1.88.51,3.27,1.37,3.84,2.49,1.67,3.28-3.07,9.49-11.17,13.62a32.65,32.65,0,0,1-11.45,3.56c3.27,1.3,9.78.17,16.2-3.1C1111.59,398.24,1116.33,392,1114.66,388.76Z"
        fill="#e1a554"
      />
      <path
        d="M1174.58,328.9c-1.39-1.4-4.5-1.61-8.08-.53a5.81,5.81,0,0,1,4.42,1.2c2.59,2.62,0,10-6.51,16.37a31.11,31.11,0,0,1-10.71,7.22c3.52.16,9.32-2.88,14.38-7.89C1174.55,338.87,1177.18,331.52,1174.58,328.9Z"
        fill="#e1a554"
      />
      <path
        d="M1187.92,297.57c-1.75-1.77-6.22-1.66-10.93.56,3.23-.81,6-.52,7.26.77,2.59,2.62,0,10-6.5,16.37a34.22,34.22,0,0,1-8.66,6.35c3.49-.77,8.15-3.55,12.32-7.68C1187.88,307.54,1190.51,300.19,1187.92,297.57Z"
        fill="#e1a554"
      />
      <ellipse
        cx="1220.74"
        cy="309.79"
        rx="5.4"
        ry="1.98"
        transform="matrix(0.81, -0.58, 0.58, 0.81, 47.7, 768.22)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1222.75,307.33c1.18,1.65-.34,2.9-2.52,4.46s-4.21,2.85-5.39,1.2a5.45,5.45,0,0,1,1.22-6.85C1218.24,304.58,1221.57,305.68,1222.75,307.33Z"
        fill="#eebf57"
      />
      <path
        d="M1218.51,305.39a4.53,4.53,0,0,1,1.47,1.23c1.18,1.65-.34,2.9-2.52,4.47a15.54,15.54,0,0,1-2.75,1.68l.13.22c1.18,1.65,3.21.36,5.39-1.2s3.7-2.81,2.52-4.46A5.42,5.42,0,0,0,1218.51,305.39Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1245.11"
        cy="267.02"
        rx="4.1"
        ry="1.51"
        transform="translate(77.14 774.41) rotate(-35.59)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1246.64,265.15c.89,1.25-.26,2.2-1.92,3.39s-3.2,2.16-4.09.91a4.15,4.15,0,0,1,.92-5.21A4,4,0,0,1,1246.64,265.15Z"
        fill="#eebf57"
      />
      <path
        d="M1243.41,263.67a3.4,3.4,0,0,1,1.12.94c.9,1.25-.26,2.2-1.92,3.39a11.12,11.12,0,0,1-2.09,1.28l.11.17c.89,1.25,2.43.27,4.09-.91s2.81-2.14,1.92-3.39A4.12,4.12,0,0,0,1243.41,263.67Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1206.88"
        cy="323.14"
        rx="5.88"
        ry="2.16"
        transform="translate(37.34 762.65) rotate(-35.59)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1209.08,320.46c1.28,1.8-.37,3.16-2.75,4.86s-4.59,3.1-5.87,1.31-1.06-5.76,1.32-7.46S1207.79,318.66,1209.08,320.46Z"
        fill="#eebf57"
      />
      <path
        d="M1204.45,318.35a4.81,4.81,0,0,1,1.61,1.34c1.28,1.8-.37,3.16-2.75,4.86a17,17,0,0,1-3,1.84c0,.08.09.16.15.24,1.28,1.79,3.49.39,5.87-1.31s4-3.06,2.75-4.86A5.94,5.94,0,0,0,1204.45,318.35Z"
        fill="#d6974f"
      />
      <path
        d="M1080.23,413.44c-.37-2.6-3.4-5.3-8-7.06a5.89,5.89,0,0,1,1.62,3.06c.72,5.06-8.28,11.08-20.78,12.87-6.73,1-13.09.61-17.64-.72,2.31,4.21,12.61,6.35,24,4.72C1072,424.52,1081,418.5,1080.23,413.44Z"
        fill="#e1a554"
      />
      <path
        d="M1067.08,439.55c-.42-2.93-5.51-6-12.18-6.46,3.34,1.27,5.58,3.23,5.85,5.12.52,3.65-6,8-15,9.28a37.12,37.12,0,0,1-7.85.31c3.29,1.36,8.55,1.83,14.18,1C1061.11,447.54,1067.6,443.19,1067.08,439.55Z"
        fill="#e1a554"
      />
      <path
        d="M1147.77,364.43c-.39-2.7-4.31-5.5-9.9-6.76,2.53,1.36,4.16,3.08,4.4,4.76.6,4.21-7.16,9.27-17.92,10.81a41.18,41.18,0,0,1-13.38-.13c3.5,2.31,10.88,3.27,18.88,2.13C1140.61,373.7,1148.37,368.64,1147.77,364.43Z"
        fill="#e1a554"
      />
      <g>
        <ellipse
          cx="1074.95"
          cy="450.96"
          rx="1.85"
          ry="5.03"
          transform="translate(612.28 1520.92) rotate(-89.37)"
          fill="#e1a554"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path
          d="M1077.82,450.21c0,1.9-1.85,2-4.35,2s-4.74-.17-4.72-2.06a5.08,5.08,0,0,1,4.69-4.49C1075.94,445.66,1077.84,448.32,1077.82,450.21Z"
          fill="#eebf57"
        />
        <path
          d="M1075.7,446.42a4.12,4.12,0,0,1,.43,1.74c0,1.89-1.86,2-4.36,2a14.88,14.88,0,0,1-3-.25,1.94,1.94,0,0,0,0,.24c0,1.89,2.21,2,4.72,2.06s4.33-.07,4.35-2A5,5,0,0,0,1075.7,446.42Z"
          fill="#d6974f"
        />
      </g>
      <g>
        <ellipse
          cx="1070.04"
          cy="401.07"
          rx="0.98"
          ry="2.67"
          transform="translate(657.31 1466.67) rotate(-89.37)"
          fill="#e1a554"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path
          d="M1071.57,400.68c0,1-1,1.06-2.31,1s-2.51-.09-2.5-1.09a2.69,2.69,0,0,1,2.48-2.38A2.59,2.59,0,0,1,1071.57,400.68Z"
          fill="#eebf57"
        />
        <path
          d="M1070.44,398.67a2.15,2.15,0,0,1,.23.92c0,1-1,1.06-2.31,1a7,7,0,0,1-1.59-.13.57.57,0,0,0,0,.13c0,1,1.17,1.08,2.5,1.09s2.29,0,2.31-1A2.69,2.69,0,0,0,1070.44,398.67Z"
          fill="#d6974f"
        />
      </g>
      <g>
        <ellipse
          cx="1120.76"
          cy="423.35"
          rx="1.59"
          ry="4.32"
          transform="translate(685.19 1539.42) rotate(-89.37)"
          fill="#e1a554"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path
          d="M1123.23,422.71c0,1.63-1.59,1.72-3.74,1.69s-4.07-.15-4-1.77a4.37,4.37,0,0,1,4-3.86A4.22,4.22,0,0,1,1123.23,422.71Z"
          fill="#eebf57"
        />
        <path
          d="M1121.4,419.45a3.59,3.59,0,0,1,.37,1.49c0,1.63-1.59,1.72-3.74,1.69a12.46,12.46,0,0,1-2.58-.21,1.48,1.48,0,0,0,0,.21c0,1.62,1.89,1.75,4,1.77s3.72-.06,3.74-1.69A4.36,4.36,0,0,0,1121.4,419.45Z"
          fill="#d6974f"
        />
      </g>
    </g>
  );
};

export default Trope4;
